export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-05-17 at 13.51.18.7db3852e.jpeg";